import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b04b4224"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "iodine-scrollable-y search-result" }

import { ReferencesSearchData } from './ReferencesSearchData.model';
import {ref, Ref} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesSearch',
  setup(__props) {

const referenceSearchList: Ref<Array<ReferencesSearchData>> = ref([
    {
        id: 227114,
        title: 'Coding Update: Minimally Invasive Surgical Sacroiliac Joint Fusion or Stabilization Procedure',
        best: true,
    },
    {
        id: 212157,
        title: 'Surgery: Musculoskeletal System, Sacroiliac Joint Arthrodesis, 27279 (Q&A)',
        best: true,
    },
    {
        id: 212110,
        title: 'Reviewing Decompression, Arthrodesis, and Osteotomy Procedures',
        best: true,
    },
    {
        id: 94252,
        title: 'Surgery: Musculoskeletal System, 20900-20938, 22633, 22634, 22802, 22843, 22853 (Q&A)',
        best: true,
    },
    {
        id: 82628,
        title: 'Surgery: Musculoskeletal System, Anterior, Posterior, Lateral Interbody Fusion, 22853 (Q&A)',
        best: true,
    },
    {
        id: 82100,
        title: 'Reporting Insertion of Spinal Biomechanical Device(s)',
        best: true,
    },
    {
        id: 80322,
        title: 'Surgery: Musculoskeletal System, 22845, 22851 (Q&A)',
        best: true,
    },
    {
        id: 77040,
        title: 'Coding Update: Total Disc Arthroplasty (22856, 22858, 0375T)',
        best: true,
    },
    {
        id: 77017,
        title: 'Surgery: Musculoskeletal System, RSB InterPlate®, 22558, 22845, 22851 (Q&A)',
        best: true,
    },
    {
        id: 76734,
        title: 'Surgery: Musculoskeletal System, Discectomy with Decompression, Fusion, Peek Cage with Moselized Bone Graft, 22551, 22845, 22851 (Q&A)',
        best: true,
    },
    {
        id: 76446,
        title: 'Surgery: Musculoskeletal System, 22845, 22851 (Q&A)',
        best: true,
    },
    {
        id: 72666,
        title: 'Surgery: Lumbar Arthrodesis, 20930-20938, 22630, 22633, 22840, 22842, 22843, 22844, 22851 (Q&A)',
        best: true,
    },
    {
        id: 30818,
        title: 'Removal and Reinsertion Spinal Instrumentation, 22855 (Q&A)',
        best: true,
    },
    {
        id: 30515,
        title: 'Musculoskeletal System/Surgery, 22851, 20931 (Q&A)',
        best: true,
    },
    {
        id: 26986,
        title: 'Percutaneous Vertebroplasty',
        best: true,
    },
    {
        id: 26885,
        title: 'Musculoskeletal System, 22851, 22899 (Q&A)',
        best: true,
    },
    {
        id: 26822,
        title: 'CPT 2000 Code and Guideline Changes: A Comprehensive Review',
        best: true,
    },
    {
        id: 26497,
        title: 'How to Code Prosthetic Devices',
        best: true,
    },
    {
        id: 83662,
        title: 'Back Issue Index–Winter 1990-December 2017',
        best: false,
    },
    {
        id: 80327,
        title: 'Surgery: Musculoskeletal System, Buttress Plates for Anterior Spinal Instrumentation, 22845-22847 (Q&A)',
        best: false,
    },
    {
        id: 74923,
        title: 'Spinal Instrumentation',
        best: false,
    },
    {
        id: 72569,
        title: 'Surgery: Musculoskeletal System, 22849, 22851 (Q&A)',
        best: false,
    },
    {
        id: 30547,
        title: 'Coding Communication: Surgery-Digestive and Medicine-Gastroenterology Codes',
        best: false,
    },
]);

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_list, { dense: "" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(referenceSearchList.value, (referencesSearchItem) => {
          return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
            key: referencesSearchItem.id,
            clickable: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, {
                avatar: "",
                class: "circle-icon-section"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "fa-solid fa-circle",
                    size: "10px",
                    color: referencesSearchItem.best ? 'primary' : 'grey'
                  }, null, 8, ["color"]),
                  _createVNode(_component_q_tooltip, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(referencesSearchItem.best ? 'Best Match' : 'Other'), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_q_item_section, { class: "search-result-item" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(referencesSearchItem.title) + " ", 1),
                  _createVNode(_component_q_tooltip, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(referencesSearchItem.title), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)), [
            [_directive_ripple]
          ])
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})